import { Card, Skeleton, Steps } from "antd";
import React from "react";
import JobInformation from "./components/JobInformationForm";
import JobDetailsForm from "./components/JobDetailsForm";
import ReviewPage from "./components/ReviewPage";
import { PartialJobInterface } from "api/jobs/dto";
import { useParams } from "react-router-dom";
import { useGetJobDetails } from "api/jobs/useGetJobDetails";
import ErrorPage from "components/ui/ErrorPage";

const PostJob = () => {
  const [current, setCurrent] = React.useState(0);
  const [formData, setFormData] = React.useState<PartialJobInterface>({});

  const { id } = useParams();

  const isEditMode = !!id;

  const { data, isLoading, error } = useGetJobDetails(id);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "Add job information",
      content: <JobInformation next={next} formData={formData} setFormData={setFormData} isEditMode={isEditMode} id={id} />,
    },
    {
      title: "Add job detail",
      content: (
        <JobDetailsForm next={next} formData={formData} setFormData={setFormData} prev={prev} isEditMode={isEditMode} id={id} />
      ),
    },
    {
      title: "Review",
      content: (
        <ReviewPage
          next={next}
          formData={formData}
          prev={prev}
          setCurrent={setCurrent}
          isEditMode={isEditMode}
          id={id}
        />
      ),
    },
  ];

  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  React.useEffect(() => {
    if (!data) return;
    setFormData(data);
  }, [data]);

  if (isLoading) {
    return (
      <Card style={{ width: "100%", marginTop: 16, height: "580px" }}>
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
      </Card>
    );
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <>
      <div className="bg-background">
        <div className="max-w-6xl mx-auto py-12">
          <Card>
            <Steps current={current} items={items} />
          </Card>
          <div>{steps[current].content}</div>
        </div>
      </div>
    </>
  );
};

export default PostJob;
